/* tslint:disable */
/* eslint-disable */
/**
 * Properties API
 * API for managing properties
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BienImmobilierIdsResponse
 */
export interface BienImmobilierIdsResponse {
    /**
     * Tous les IDs de biens correspondant au filtre (pour « tout sélectionner »)
     * @type {Array<string>}
     * @memberof BienImmobilierIdsResponse
     */
    ids: Array<string>;
}

/**
 * Check if a given object implements the BienImmobilierIdsResponse interface.
 */
export function instanceOfBienImmobilierIdsResponse(value: object): value is BienImmobilierIdsResponse {
    if (!('ids' in value) || value['ids'] === undefined) return false;
    return true;
}

export function BienImmobilierIdsResponseFromJSON(json: any): BienImmobilierIdsResponse {
    return BienImmobilierIdsResponseFromJSONTyped(json, false);
}

export function BienImmobilierIdsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BienImmobilierIdsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'ids': json['ids'],
    };
}

export function BienImmobilierIdsResponseToJSON(json: any): BienImmobilierIdsResponse {
    return BienImmobilierIdsResponseToJSONTyped(json, false);
}

export function BienImmobilierIdsResponseToJSONTyped(value?: BienImmobilierIdsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ids': value['ids'],
    };
}

